module.exports = __webpack_public_path__ + "img/ilustraciones_medico2.1660302e.svg";